import React, { Fragment, useState, useEffect } from 'react';
import {
  Box,
  CardMedia,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  Switch,
  TextField,
  Typography,
  InputAdornment,
  MenuItem,
  Button,
  FormHelperText
} from '@mui/material';
import { FacebookRounded, Instagram, WhatsApp, X, LinkedIn, Close, KeyboardArrowLeft } from '@mui/icons-material';
import Colors from '../../../Assets/Styles/Colors';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import { OutlineInputField, InputField } from '../../../Components/Fields/TextFields';
import SelectField from '../../../Components/Fields/SelectField';
import { PrimaryButton } from '../../../Components/Buttons';
import { PhotoLibrary } from '@mui/icons-material';
import styled from '@emotion/styled';
import { useForm } from 'react-hook-form';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import { baseUrl } from '../../../../axios';
import AdGuruServices from '../../../Api/AdGuru/AdGuruServices';
import { useNavigate } from 'react-router-dom';
import { ErrorToaster, SuccessToaster } from '../../../Components/Toaster/Toaster';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import axios from 'axios';
import { DatePicker, LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AddressForm from '../../../Components/AddressForm';
import moment from 'moment';

const CustomSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : Colors.primary,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));

function CreateAdGuru() {
  const socialData = [
    {
      _id: 1001,
      value: "f_link",
      name: "Facebook",
      icon: <FacebookRounded sx={{ color: Colors.primary }} />
    },
    {
      _id: 1002,
      value: "t_link",
      name: "Twitter",
      icon: <X sx={{ color: Colors.primary }} />
    },
    {
      _id: 1003,
      value: "l_link",
      name: "LinkedIn",
      icon: <LinkedIn sx={{ color: Colors.primary }} />
    },
    {
      _id: 1004,
      value: "w_link",
      name: "Instagram",
      icon: <Instagram sx={{ color: Colors.primary }} />
    },
  ]
  const [image, setImage] = useState("");
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({ id: "", name: "" });
  const [selectedDate, setSelectedDate] = useState(null);
  const [time, setTime] = useState(null);
  const [open, setOpen] = useState(false);
  const [addressData, setAddressData] = useState(null);
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();

  const navigate = useNavigate();

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  };

  const submitForm = async (formData) => {
    const obj = {
      title: formData?.AdGuruTitle,
      image: image,
      content: formData?.description,
      category: selectedCategory?.id,
      offered_by: formData?.offeredBy,
      date: selectedDate,
      time: time,
      venue: addressData?.address,
      type: "adguru"
    }
    if (image == "") {
      ErrorToaster("Please select an image")
    } else {
      setLoading(true);
      try {
        const result = await AdGuruServices.createAdGuru(obj);
        if (result?.responseCode == 200) {
          SuccessToaster(result?.message);
          navigate("/adguru-list");
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getAllCategories = async () => {
    try {
      const result = await CategoriesServices.getAllCategories("", 1, 100, "adguru");
      const filteredCategories = result?.data?.categories?.filter((item) => item.isActive == true);
      setCategories(filteredCategories);
      // console.log(result);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDateChange = (date) => {
    const formattedDate = moment(date).toDate();
    setSelectedDate(formattedDate);
  };

  const handleTimeChange = (time) => {
    const formattedTime = moment(time)
    setTime(formattedTime);
  };

  const saveAddress = async (data) => {
    try {
      setOpen(false);
      setAddressData(data);
      setValue("address", data?.address);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <Fragment>
      <AddressForm open={open} onClose={() => setOpen(false)} save={(data) => saveAddress(data)} />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Create AdGuru
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Create AdGuru"]} />
          </Grid>
        </Grid>

        <Box sx={{ mt: 3, p: 2, bgcolor: Colors.white, borderRadius: "12px" }}>
          <Grid container spacing={2} rowS component={"form"} onSubmit={handleSubmit(submitForm)}>
            <Grid item md={6}>
              <Box>
                <InputField
                  label={"Adguru Title"}
                  register={register("AdGuruTitle", {
                    required: "Please enter a title"
                  })}
                  error={errors?.AdGuruTitle?.message}
                  helperText={errors?.AdGuruTitle?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box>
                <SelectField
                  data={categories}
                  stateValue={selectedCategory.name}
                  setState={(id, name) => setSelectedCategory({ id: id, name: name })}
                  label={"Categories"}
                  register={register("category", {
                    required: "Pelase selec a category",
                  })}
                  error={errors?.category?.message}
                />
              </Box>
            </Grid>
            <Grid item md={6}>
              <Box
                sx={{
                  height: "126px",
                  border: image !== "" ? "none" : "1px solid rgba(0, 0, 0, 0.23)",
                  borderRadius: "4px",
                  ":hover": {
                    borderColor: image !== "" ? "transparent" : "#1F1F1F"
                  }
                }}
              >
                {image !== "" ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      position: "relative",
                      height: "100%",
                    }}
                  >
                    <CardMedia
                      component={"img"}
                      src={baseUrl + image}
                      sx={{
                        width: "120px",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                    <Box sx={{ position: "absolute", top: 0, right: 0 }}>
                      <IconButton sx={{ p: 0 }} onClick={() => setImage("")}>
                        <Close sx={{ color: Colors.primary }} />
                      </IconButton>
                    </Box>
                  </Box>
                ) : (
                  <Fragment>
                    <InputLabel
                      htmlFor="image-input"
                      sx={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px"
                      }}
                    >
                      <PhotoLibrary sx={{ fontSize: "36px" }} />
                      <Typography>
                        Upload Image
                      </Typography>
                    </InputLabel>
                    <input
                      id="image-input"
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleFileUpload(e.target.files[0])}
                      style={{ display: "none" }}
                    />
                  </Fragment>
                )}
              </Box>
            </Grid>
            <Grid item md={6}>
              <Grid container spacing={2}>
                <Grid item md={12}>
                  <Box>
                    <InputField
                      label={"Offered By"}
                      register={register("offeredBy", {
                        required: "Offered By"
                      })}
                      error={errors?.offeredBy?.message}
                      helperText={errors?.offeredBy?.message}
                    />
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Grid container spacing={2}>
                    <Grid item md={6}>
                      <Box>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            {...register("date", {
                              required: selectedDate == null ? "Please select a date" : false
                            })}
                            label="Date"
                            slotProps={{
                              textField: {
                                fullWidth: true
                              }
                            }}

                            onChange={(date) => handleDateChange(date)}
                          />
                          <FormHelperText sx={{ color: errors?.date && Colors.danger }}>
                            {errors?.date?.message}
                          </FormHelperText>
                        </LocalizationProvider>
                      </Box>
                    </Grid>
                    <Grid item md={6}>
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <TimePicker
                          {...register("time", {
                            required: time == null ? "Time" : false
                          })}
                          ampm={false}
                          label="Time"
                          slotProps={{
                            textField: {
                              fullWidth: true
                            }
                          }}
                          onChange={(time) => handleTimeChange(time)}
                        />
                        <FormHelperText sx={{ color: errors?.startTime && Colors.danger }}>
                          {errors?.startTime?.message}
                        </FormHelperText>
                      </LocalizationProvider>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={12}>
              <Box>
                <TextField
                  {...register("address", {
                    required: "Please select a location"
                  })}
                  onClick={() => setOpen(true)}
                  fullWidth
                  label={addressData?.address ? null : "Address"}
                  InputProps={{ readOnly: true }}
                  value={addressData?.address}
                  error={errors?.address && true}
                  helperText={errors?.address?.message}
                />
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box>
                <InputField
                  multiline={true}
                  rows={3}
                  label={"Description"}
                  register={register("description", {
                    required: "Please enter a description"
                  })}
                  error={errors?.description?.message}
                  helperText={errors?.description?.message}
                />
              </Box>
            </Grid>
            <Grid item md={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end"
                }}
              >
                <PrimaryButton
                  title={"Submit"}
                  type={"submit"}
                  loading={loading}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Fragment >
  )
}

export default CreateAdGuru